export const getRandomIntOnRange = (min, max) => {
  const minRounded = Math.ceil(min);
  const maxRounded = Math.floor(max);

  return Math.floor(Math.random() * (maxRounded - minRounded) + minRounded);
};
